import { IMPORT_FILE_TYPE_LABELS, type ImportJobDTO } from '@hearth/shared';
import { FileText } from 'lucide-react';
import { Card, CardBody } from '../../components/ui';
import { formatFileSize } from '../../lib/format';

/**
 * How the uploaded file was read — its format, and every note the reader left (sheet used, rows skipped above the
 * column names, text encoding, leads found in free text) — so a surprising column list has an explanation.
 */
export function ImportFileInfo({ job }: { job: ImportJobDTO }) {
  return (
    <Card className="mb-4">
      <CardBody className="flex gap-3 text-[13px]">
        <FileText className="mt-0.5 size-4 shrink-0 text-slate-400" aria-hidden />
        <div className="min-w-0">
          <p className="text-slate-700">
            Read as <strong>{IMPORT_FILE_TYPE_LABELS[job.fileType]}</strong>
            {job.fileSize !== null && <> · {formatFileSize(job.fileSize)}</>}
          </p>
          {job.parseNotes.length > 0 && (
            <ul className="mt-1 list-disc space-y-0.5 pl-4 text-slate-600">
              {job.parseNotes.map((note) => (
                <li key={note}>{note}</li>
              ))}
            </ul>
          )}
        </div>
      </CardBody>
    </Card>
  );
}
